import React, { useContext } from 'react';
import { Container } from '@pwskills/rachnaui';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import ProfessionalThemeHeader from '@/components/common/Header/ProfessionalThemeHeader';
import Headers from '../../common/Header';
import MentorCards from './MentorCards/index';

const OurMentors = ({ isAmateur = true }: { isAmateur?: boolean }) => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { instructors } = courseDetails?.courseMetaDetails || {};

  return (
    <div style={{ marginTop: '48px' }}>
      {instructors && instructors?.length > 0 && (
        <section id="mentors" data-title="Mentors" className="">
          <Container className="medium:!px-8 large:!px-20 py-8 medium:py-14">
            <div className="flex flex-col gap-9">
              {isAmateur && (
                <header className="flex justify-center text-[#3D3D3D]">
                  <Headers
                    title="Meet your Mentors"
                    classes="flex w-full !min-w-full justify-center text-gray-850 medium:w-auto text-center !self-center !w-[50%]  medium:!w-full"
                  />
                </header>
              )}
              {!isAmateur && (
                <ProfessionalThemeHeader
                  title="Guidance by Experts: Our Esteemed Faculty"
                  subtitle="Experience excellence in mentorship from industry-leading professional."
                />
              )}
              {instructors && <MentorCards instructors={instructors} isSocialIconEnabled />}
            </div>
          </Container>
        </section>
      )}
    </div>
  );
};

export default OurMentors;
